"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Button = function Button(_ref) {
  var text = _ref.text,
      loading = _ref.loading,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn--primary ".concat(className),
    disabled: disabled || loading,
    onClick: onClick
  }, loading && /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: "circle-notch",
    spin: true,
    style: {
      marginRight: '5px'
    }
  }), text);
};

var _default = Button;
exports["default"] = _default;